import React, { useEffect, useRef, useState } from 'react';
import FullScreenVideoComponent from '../../FloatingVideo/VideoComponent';
import { NewVideo, VideoContainer, VideoWrapper, NewUxVideo } from './styled';
import { isDesktopUser } from '../../../Utils/ProductUtils';

const VideoCard = (props) => {
  const {
    url,
    videoTitle,
    videoDescription,
    isForJoyfulPage,
    showNewProductVideoCardUx,
  } = props;
  const [showFullScreenVideo, setShowFullScreenVideo] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (videoRef.current) {
            if (entry.isIntersecting) {
              videoRef.current.play();
            } else {
              videoRef.current.pause();
            }
          }
        });
      },
      { threshold: 0.5 },
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  if (showFullScreenVideo) {
    return (
      <FullScreenVideoComponent
        key={0}
        videoData={{ url }}
        setShowFullScreenVideo={setShowFullScreenVideo}
        autoPlay={true}
        remainingHeight={null}
        isCartOpen={false}
        openVideoFullScreen={true}
      />
    );
  }

  return showNewProductVideoCardUx ? (
    <VideoContainer
      onClick={() => setShowFullScreenVideo(true)}
      className="video-card"
      isForJoyfulPage
      showNewProductVideoCardUx={showNewProductVideoCardUx}
    >
      <video
        ref={videoRef}
        src={url}
        muted
        autoPlay
        loop
        playsInline
        className="video-player"
      />
    </VideoContainer>
  ) : (
    <NewUxVideo
      onClick={() => setShowFullScreenVideo(true)}
      className="video-card"
      showNewProductVideoCardUx={showNewProductVideoCardUx}
      isForJoyfulPage={isForJoyfulPage}
    >
      <VideoWrapper>
        <video
          ref={videoRef}
          src={url}
          muted
          autoPlay
          loop
          playsInline
          className="video-player"
        />
        <div className="fade-overlay" />
      </VideoWrapper>
      {(videoTitle || videoDescription) && (
        <div className="white-caption-block">
          {videoTitle && <div className="Video-title">{videoTitle}</div>}
          {videoDescription && (
            <div className="Video-description">{videoDescription}</div>
          )}
        </div>
      )}
    </NewUxVideo>
  );
};

export default VideoCard;
